export const applyTemplate = (
  tpl: string,
  obj: Record<string, unknown>
): string =>
  tpl.replace(/\{\{(.*?)\}\}/g, (_, key) => String(obj[key.trim()] ?? ''));
